import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { t } from "@/i18n-js/instance";
import { LoaderRow } from "@/react/components/shared/LoaderRow";
import { EmptyState } from "@/react/components/shared/uikit/EmptyState";
import type { ReusableBlock } from "@/react/hooks/api/useReusableBlocks";
import { useGetReusableBlocks } from "@/react/hooks/api/useReusableBlocks";
import { ReusableBlockPreview } from "./ReusableBlockPreview";

export const ReusableBlockList = () => {
  const { data: reusableBlocks, isLoading } = useGetReusableBlocks();

  if (isLoading) {
    return (
      <OverlayScrollbarsComponent className="w-2/3">
        <div className="flex w-full flex-col gap-6 px-6 py-5">
          <LoaderRow />
        </div>
      </OverlayScrollbarsComponent>
    );
  }

  if (!reusableBlocks || reusableBlocks.length === 0) {
    return (
      <div className="w-2/3">
        <EmptyState
          header={t("builder_ui.block_list.no_saved_blocks_header")}
          description={t("builder_ui.block_list.no_saved_blocks_description")}
          fontSize="sm"
        />
      </div>
    );
  }

  return (
    <OverlayScrollbarsComponent className="w-2/3">
      <div className="flex w-full flex-col gap-6 px-6 py-5">
        {reusableBlocks.map((block: ReusableBlock) => (
          <ReusableBlockPreview key={block.id} block={block} />
        ))}
      </div>
    </OverlayScrollbarsComponent>
  );
};
